module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img30.d826b8f8.jpg";